export default class DomainSelectorController {
    /* @ngInject */
    constructor($log, $location, ThingsService) {
        this.$log = $log;
        this.$location = $location;
        this.ThingsService = ThingsService;
        this.domain = {};
        this.selectedDomainId = undefined;
        this.selectedDomainName = undefined;
        this.isLoading = true;
    }

    $onInit() {
        this.isLoading = true;
        this.ThingsService.getDomains()
            .then((rootDomain) => {
                this.domain = rootDomain;

                // Select any already selected domain, this needs to be done
                // after the domains are retrieved to use the correct name
                this.selectedDomainId = this.ThingsService.selectedDomain;
                this.selectedDomainName = this.resolveDomainName();
            })
            .catch((error) => {
                this.$log.info(`Error getting domains: ${error}`);
            })
            .finally(() => {
                this.isLoading = false;
            });
    }

    select(domainId) {
        this.selectedDomainId = domainId;
        this.selectedDomainName = this.resolveDomainName();
        this.onSelect({ domainId });
    }

    reset() {
        this.selectedDomainId = undefined;
        this.onSelect({ domainId: undefined });
    }

    resolveDomainName() {
        const domain = this.domain.allChildren().filter(d => d.id === this.selectedDomainId).shift();
        return domain !== undefined ? domain.name : '';
    }
}



// WEBPACK FOOTER //
// ./src/app/components/domain-selector/domain-selector.controller.js